export const prefixKey = 'AG-SCHEDULES-FRONTEND'

export const storageKeys = {
  prefix: 'agendamento-consulta | ',
  token: 'SSO_TOKEN_SESSION',
  validadeToken: 'SSO_TOKEN_VALID_UNTIL',
  refreshToken: 'SSO_REFRESH_TOKEN_SESSION',
  validadeRefreshToken: 'SSO_REFRESH_TOKEN_VALID_UNTIL',
  sessionId: 'SESSION_ID',
  deviceId: 'deviceId',
  patientData: 'PATIENT_DATA',
  lastSearchLocal: 'lastSearchLocal',
  lastSearchPayment: 'lastSearchPayment',
  doraIntegrationId: 'dora-integration-id',
  doraIntegrationIdNaoLogado: 'dora_automatizada_naologado',
  incentiveLoginToast: 'alreadyShowToastLoginIncentive',
  loginIncentivePaymentToast: 'hasShownLoginIncentivePaymentToast',
  listingHoursQuantity: 'listingHoursQuantity',
  CART_RECOVERY_DATA: 'cartRecoveryData',
  webViewGeolocationCoordinates: 'app_location',
  webViewDeviceId: 'RDSL_APP_DEVICE_ID',
  webViewCookiesPermitted: 'RDSL_HAS_WEBVIEW_COOKIES_PERMITTED',
  genericErrorShown: 'GENERIC_ERROR_SHOWN',
  homeIntrusiveAppBanner: 'homeIntrusiveAppBanner'
}
